const { setDateToCurrentYear, addOneDay } = require('./../../pages/helpers/dateHelpers');

const addMap = () => {
  const address1 = document.querySelector('.event-info__address__street').innerHTML.trim();
  const address2 = document.querySelector('.event-info__address__citystate').innerHTML.trim();

  const address = !address1 ? address2 : address1;
  var geocoder = new google.maps.Geocoder();

  geocoder.geocode({address}, (results, status) => {
    var center = results[0].geometry.location;
    var map = new google.maps.Map(document.getElementById('map'), {
      zoom: 10,
      center
    });
    var marker = new google.maps.Marker({
      position: center,
      map: map
    });
  });
};

const getDateFromNode = (node) => {
  let endDate;
  const text = node.innerHTML.trim();
  if (text.match(/\-/g)) {
    endDate = new Date(text.split('-')[1].trim());
  } else {
    endDate = new Date(text);
  }

  setDateToCurrentYear(endDate);

  return endDate;
};

const checkExpiredDate = () => {
  const now = Date.now();
  const dateNode = document.querySelector('.event-page__date__day');

  const eventDate = getDateFromNode(dateNode);

  if (Date.now() > addOneDay(eventDate)) {
    const expiredFlashNode = document.querySelector('.event-expired');
    expiredFlashNode.classList.remove('hide');
  }
};

const init = () => {
  addMap();
  checkExpiredDate();
};

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./src/assets/js/event.js